/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadChatAttachmentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UploadChatAttachmentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UploadChatAttachmentSecurityOption3 = {
  chatSessionsTokenHeaderGramChatSession: string;
  projectSlugHeaderGramProject: string;
};

export type UploadChatAttachmentSecurity = {
  option1?: UploadChatAttachmentSecurityOption1 | undefined;
  option2?: UploadChatAttachmentSecurityOption2 | undefined;
  option3?: UploadChatAttachmentSecurityOption3 | undefined;
};

export type UploadChatAttachmentRequest = {
  contentLength: number;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
};

/** @internal */
export type UploadChatAttachmentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UploadChatAttachmentSecurityOption1$outboundSchema: z.ZodMiniType<
  UploadChatAttachmentSecurityOption1$Outbound,
  UploadChatAttachmentSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadChatAttachmentSecurityOption1ToJSON(
  uploadChatAttachmentSecurityOption1: UploadChatAttachmentSecurityOption1,
): string {
  return JSON.stringify(
    UploadChatAttachmentSecurityOption1$outboundSchema.parse(
      uploadChatAttachmentSecurityOption1,
    ),
  );
}

/** @internal */
export type UploadChatAttachmentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UploadChatAttachmentSecurityOption2$outboundSchema: z.ZodMiniType<
  UploadChatAttachmentSecurityOption2$Outbound,
  UploadChatAttachmentSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function uploadChatAttachmentSecurityOption2ToJSON(
  uploadChatAttachmentSecurityOption2: UploadChatAttachmentSecurityOption2,
): string {
  return JSON.stringify(
    UploadChatAttachmentSecurityOption2$outboundSchema.parse(
      uploadChatAttachmentSecurityOption2,
    ),
  );
}

/** @internal */
export type UploadChatAttachmentSecurityOption3$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UploadChatAttachmentSecurityOption3$outboundSchema: z.ZodMiniType<
  UploadChatAttachmentSecurityOption3$Outbound,
  UploadChatAttachmentSecurityOption3
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadChatAttachmentSecurityOption3ToJSON(
  uploadChatAttachmentSecurityOption3: UploadChatAttachmentSecurityOption3,
): string {
  return JSON.stringify(
    UploadChatAttachmentSecurityOption3$outboundSchema.parse(
      uploadChatAttachmentSecurityOption3,
    ),
  );
}

/** @internal */
export type UploadChatAttachmentSecurity$Outbound = {
  Option1?: UploadChatAttachmentSecurityOption1$Outbound | undefined;
  Option2?: UploadChatAttachmentSecurityOption2$Outbound | undefined;
  Option3?: UploadChatAttachmentSecurityOption3$Outbound | undefined;
};

/** @internal */
export const UploadChatAttachmentSecurity$outboundSchema: z.ZodMiniType<
  UploadChatAttachmentSecurity$Outbound,
  UploadChatAttachmentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UploadChatAttachmentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UploadChatAttachmentSecurityOption2$outboundSchema),
    ),
    option3: z.optional(
      z.lazy(() => UploadChatAttachmentSecurityOption3$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
      option3: "Option3",
    });
  }),
);

export function uploadChatAttachmentSecurityToJSON(
  uploadChatAttachmentSecurity: UploadChatAttachmentSecurity,
): string {
  return JSON.stringify(
    UploadChatAttachmentSecurity$outboundSchema.parse(
      uploadChatAttachmentSecurity,
    ),
  );
}

/** @internal */
export type UploadChatAttachmentRequest$Outbound = {
  "Content-Length": number;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
};

/** @internal */
export const UploadChatAttachmentRequest$outboundSchema: z.ZodMiniType<
  UploadChatAttachmentRequest$Outbound,
  UploadChatAttachmentRequest
> = z.pipe(
  z.object({
    contentLength: z.int(),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentLength: "Content-Length",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      gramSession: "Gram-Session",
      gramChatSession: "Gram-Chat-Session",
    });
  }),
);

export function uploadChatAttachmentRequestToJSON(
  uploadChatAttachmentRequest: UploadChatAttachmentRequest,
): string {
  return JSON.stringify(
    UploadChatAttachmentRequest$outboundSchema.parse(
      uploadChatAttachmentRequest,
    ),
  );
}
